import { CompanyInfoCard } from '@/pages/client-portal/ui/cards/company-info-card/company-info-card'

import {
  type ClientPortalCompanyData,
  type ClientPortalEoirCaseHistoryItem,
  type ClientPortalEoirCaseInformation,
  type ClientPortalEoirCurrentStatus,
} from '@/lib/queries/case-dashboard/types'
import '@/lib/queries/case-dashboard/v1/portal/eoir-cases/types'
import { cn } from '@/lib/utils'

import { CaseHistoryCard } from '../cards/case-history-card/case-history-card'
import { CaseInfoCard } from '../cards/case-info-card/case-info-card'

export interface BasicInformationEoirProps {
  caseData?: ClientPortalEoirCaseInformation
  companyData?: ClientPortalCompanyData
  currentStatus?: ClientPortalEoirCurrentStatus
  historyData?: ClientPortalEoirCaseHistoryItem[]
}

export const BasicInformationEoir = ({
  caseData,
  companyData,
  currentStatus,
  historyData,
}: BasicInformationEoirProps) => {
  const { alienNumber } = caseData ?? {}
  const { logo: companyLogo, name: companyName } = companyData ?? {}

  return (
    <div className={cn('flex flex-col gap-y-5 lg:grid lg:grid-cols-[400px_auto] lg:grid-rows-[170px_auto] lg:gap-5')}>
      <CompanyInfoCard companyLogo={companyLogo} companyName={companyName} />
      <CaseInfoCard caseType="EOIR" caseNumber={`A-${alienNumber}`} />
      <CaseHistoryCard currentStatus={currentStatus} historyData={historyData} />
    </div>
  )
}
